import paymentApi from '../../../payment-api'
import { initialSignUpState } from '../actions'
import { getPrice } from '../step-wizard/actions'

export const setSuggestion = async (state, membershipId) => {
  const signUpSuggestion = await paymentApi.get(`/memberships/${membershipId}`)

  const nextState = {
    ...initialSignUpState,
    signUpSuggestion
  }

  const price = await getPrice(nextState)

  return {
    ...nextState,
    ...price
  }
}

export const updateInput = async (state, key, value, membershipId) => {
  // Build the next state
  let nextState = {
    ...state,
    signUpInput: {
      ...state.signUpInput,
      [key]: value
    }
  }

  const withClub = nextState.signUpInput.club ? `?club_id=${nextState.signUpInput.club}` : ''
  const signUpSuggestion = await paymentApi.get(`/memberships/${membershipId}${withClub}`)

  nextState = {
    ...nextState,
    signUpSuggestion
  }

  // Calculate the new price
  const price = await getPrice(nextState)

  return {
    ...nextState,
    ...price
  }
}

export const setInputAndAddOns = async (state, membershipId, inputs, addOns) => {
  // Build the next state
  let nextState = {
    ...initialSignUpState,
    signUpInput: {
      ...inputs,
      club: parseInt(inputs.club)
    },
    signUpAddOns: addOns
  }

  const withClub = nextState.signUpInput.club ? `?club_id=${nextState.signUpInput.club}` : ''
  const signUpSuggestion = await paymentApi.get(`/memberships/${membershipId}${withClub}`)

  // Insert the suggestion/upgrade into the next state
  nextState = {
    ...nextState,
    signUpSuggestion
  }

  // Calculate the new price
  const price = await getPrice({ ...state, ...nextState })

  return {
    ...nextState,
    ...price
  }
}

export const setExclusiveAndAddons = async (state, membershipId, clubId, addOns) => {
  // Build the next state
  let nextState = {
    ...initialSignUpState,
    signUpInput: {
      club: parseInt(clubId)
    },
    signUpAddOns: addOns
  }

  const withClub = nextState.signUpInput.club ? `?club_id=${nextState.signUpInput.club}` : ''
  const signUpSuggestion = await paymentApi.get(`/memberships/${membershipId}${withClub}`)

  // Insert the suggestion/upgrade into the next state
  nextState = {
    ...nextState,
    signUpSuggestion
  }

  // Calculate the new price
  const price = await getPrice({ ...state, ...nextState })

  return {
    ...nextState,
    ...price
  }
}



// WEBPACK FOOTER //
// ./components/signup-flow/step-membership/actions.js